import { makeImmutable } from "../../../core";
export class AbsoluteDatePreorderSettingsType {
    constructor(params) {
        this.type = "AbsoluteDate";
        this.buffer = params.buffer;
        this.range = params.range;
        makeImmutable(this);
    }
    eq(other) {
        return this.range.eq(other.range) && this.buffer.eq(other.buffer);
    }
    toString() {
        var _a;
        return `${this.type}[addWorkdays=${(_a = this.buffer.addWorkdays) !== null && _a !== void 0 ? _a : "null"},range={${this.range.toString()}}]`;
    }
}
